import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: 'tomato-grotesk, sans-serif',
    body: 'moderat, sans-serif', // Set body font to moderat
  },
  // Add other theme customizations here
});

export default theme; 